export const BASEMAPS: any = [
    {
        imagem: 'https://www.arcgis.com/sharing/rest/content/items/d8855ee4d3d74413babfb0f41203b168/info/thumbnail/world_street_map.jpg',
        url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer',
        titulo: 'Ruas'
    },
    {
        imagem: 'https://www.arcgis.com/sharing/rest/content/items/2ef69c75a41f49ca87d7da502c2ad779/info/thumbnail/imagery_labels.jpg',
        url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer',
        titulo: 'Imagem'
    },
    {
        imagem: 'https://www.arcgis.com/sharing/rest/content/items/af0c80033e4a4f878ec4a2b72728ad03/info/thumbnail/Terrain_Labels_Web_map.jpg',
        url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
        url2: 'https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer',
        titulo: 'Imagem com Rótulos'
    },
    {
        imagem: 'https://www.arcgis.com/sharing/rest/content/items/d9964838619a4bed9f909cfa604fe526/info/thumbnail/topo_map_2.jpg',
        url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer',
        titulo: 'Topográfico'
    },
    {
        imagem: 'https://www.arcgis.com/sharing/rest/content/items/7a14b70e2e784f7eaa52a4b13195ad0c/info/thumbnail/DGCanvasBase.png',
        url: 'https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Dark_Gray_Base/MapServer',
        titulo: 'Mapa Cinza Escuro'
    },
    {
        imagem: 'https://www.arcgis.com/sharing/rest/content/items/74fb30d11311472c831a7e24ae5066f9/info/thumbnail/light_gray_canvas.jpg',
        url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer',
        titulo: 'Mapa Cinza Claro'
    }
];